<template>
  <el-dialog
    title="抵扣明细"
    :visible.sync="dialogVisible"
    width="900px"
    :close-on-click-modal="false"
  >
    <div v-loading="loading">
      <el-table :data="detail.list" class="deduction-table" border>
        <el-table-column label="费项" prop="feeTypeName" min-width="180" />
        <el-table-column label="应收金额（元）" prop="receivableAmount" min-width="180" />
        <el-table-column label="实际抵扣金额（元）" prop="discountAmount" min-width="180" />
        <el-table-column label="司机实付金额（元）" prop="payAmount" min-width="180" />
      </el-table>
      <div class="deduction-total-row">
        <div class="total-cell total-label">合计</div>
        <div class="total-cell">{{ detail.totalReceivableAmount }}</div>
        <div class="total-cell">{{ detail.totalDiscountAmount }}</div>
        <div class="total-cell">{{ detail.totalPayAmount }}</div>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { verifyCouponDetailList } from '@/api/domain/activity'

export default {
  name: 'DeductionDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    middleSubOrderId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      detail: {
        list: [],
        totalReceivableAmount: '0.00',
        totalDiscountAmount: '0.00',
        totalPayAmount: '0.00',
      },
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  watch: {
    dialogVisible: {
      immediate: true,
      handler(val) {
        if (!val) return
        this.getDetail()
      },
    },
  },
  methods: {
    normalizeAmount(value) {
      if (value === null || value === undefined || value === '') return '0.00'
      const num = Number(value)
      if (Number.isNaN(num)) return String(value)
      return num.toFixed(2)
    },
    async getDetail() {
      if (!this.middleSubOrderId) return
      this.loading = true
      this.detail = {
        list: [],
        totalReceivableAmount: '0.00',
        totalDiscountAmount: '0.00',
        totalPayAmount: '0.00',
      }
      try {
        const { code, data: rawData, msg } = await verifyCouponDetailList({
          middleSubOrderId: this.middleSubOrderId,
        })
        if (code !== 1) {
          this.$message.error(msg || '查询抵扣明细失败')
          return
        }
        const data = rawData || {}
        this.detail = {
          list: (data.feeInfoList || []).map((item) => ({
            feeTypeName: item.feeTypeName || '--',
            receivableAmount: this.normalizeAmount(item.receivableAmount),
            discountAmount: this.normalizeAmount(item.discountAmount),
            payAmount: this.normalizeAmount(item.payAmount),
          })),
          totalReceivableAmount: this.normalizeAmount(data.totalReceivableAmount),
          totalDiscountAmount: this.normalizeAmount(data.totalDiscountAmount),
          totalPayAmount: this.normalizeAmount(data.totalPayAmount),
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.deduction-table {
  margin-top: 4px;
}

.deduction-total-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border: 1px solid #ebeef5;
  border-top: none;
}

.total-cell {
  padding: 14px 12px;
  font-size: 16px;
  color: #223150;
  font-weight: 500;
}

.total-label {
  font-weight: 700;
}
</style>
